export default "__VITE_ASSET__BD8Acds9__"